module.exports = __webpack_public_path__ + "img/2025-12-20d_1.440aeb56.jpg";